import { render, staticRenderFns } from "./electricityEmissions.vue?vue&type=template&id=2c42208d&scoped=true&"
import script from "./electricityEmissions.vue?vue&type=script&lang=js&"
export * from "./electricityEmissions.vue?vue&type=script&lang=js&"
import style0 from "./electricityEmissions.vue?vue&type=style&index=0&id=2c42208d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c42208d",
  null
  
)

export default component.exports